const LogKeys =  {
    Payment : "Payment",
    GlobalErrorHandler : "GlobalErrorHandler",
    WebGlobalErrorHandler : "WebGlobalErrorHandler",
    ServiceError:"Service Error",
    ServerError:"Server Error",
};

export default LogKeys;